import React from 'react';
import styled from '@emotion/styled';
import * as actions from '../../actions';
import { useSelector, useDispatch, useStaffCan } from '~Hooks';
import { useHistory } from 'react-router';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 60px;
  border-bottom: solid 2px #d2d2d2;
  padding: 0 20px;
`;

const Title = styled.div`
  font-weight: bold;
  font-size: 21px;
`;

interface HeaderProps {
  icon?: string;
  title: string | null;
  textAlign?: any;
}

const Header = ({ icon, title, textAlign }: HeaderProps) => {
  const dispatch = useDispatch();
  const staffCan = useStaffCan();
  const history = useHistory();
  const mainMenu = useSelector((state) => state.mainMenu);

  const toggleMenu = () => {
    dispatch(actions.toggleMainMenu(!mainMenu));
  };

  return (
    <Wrapper style={{ textAlign }}>
      <Title>{title}</Title>
    </Wrapper>
  );
};

export default Header;
